import script from "./GlobalLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./GlobalLoading.vue?vue&type=script&setup=true&lang=js"

import "./GlobalLoading.vue?vue&type=style&index=0&id=151fa930&lang=css"

const __exports__ = script;

export default __exports__